__turbopack_context__.v({
  "actionContainer": "Lists-module-scss-module__OCwcsa__actionContainer",
  "cellContent": "Lists-module-scss-module__OCwcsa__cellContent",
  "cellTooltipContent": "Lists-module-scss-module__OCwcsa__cellTooltipContent",
  "contextDropdownContainer": "Lists-module-scss-module__OCwcsa__contextDropdownContainer",
  "contextDropdownItem": "Lists-module-scss-module__OCwcsa__contextDropdownItem",
  "contextDropdownWrapper": "Lists-module-scss-module__OCwcsa__contextDropdownWrapper",
  "contextMenu": "Lists-module-scss-module__OCwcsa__contextMenu",
  "detailRowCell": "Lists-module-scss-module__OCwcsa__detailRowCell",
  "expandableRow": "Lists-module-scss-module__OCwcsa__expandableRow",
  "expanderContent": "Lists-module-scss-module__OCwcsa__expanderContent",
  "extraInfoIcon": "Lists-module-scss-module__OCwcsa__extraInfoIcon",
  "gridContainer": "Lists-module-scss-module__OCwcsa__gridContainer",
  "header": "Lists-module-scss-module__OCwcsa__header",
  "iconChevronDown": "Lists-module-scss-module__OCwcsa__iconChevronDown",
  "iconChevronUp": "Lists-module-scss-module__OCwcsa__iconChevronUp",
  "linedRows": "Lists-module-scss-module__OCwcsa__linedRows",
  "rightAlignCell": "Lists-module-scss-module__OCwcsa__rightAlignCell",
  "rowAction": "Lists-module-scss-module__OCwcsa__rowAction",
  "supplementalOnMobile": "Lists-module-scss-module__OCwcsa__supplementalOnMobile",
  "table": "Lists-module-scss-module__OCwcsa__table",
});
